export default {
  title: "Production overview",
  total: "Total"
};
